// extracted by mini-css-extract-plugin
module.exports = {"DeleteLink":"SubtypeListRow_DeleteLink__G3nsh","DropdownMenuIcon":"SubtypeListRow_DropdownMenuIcon__D8yCL"};